import {DAY, TEN_DAYS} from '../constants/value';

export function getDateProperty(seconds: number) {
  const date = toLocalDate(seconds);

  return {
    minute: date.getMinutes(),
    hour: date.getHours(),
    day: date.getDate(),
    month: date.getMonth(),
    year: date.getFullYear(),
  } as const
}

export function is10DaysBeforeExpired(expiredTimeInSeconds: number): boolean {
  return expiredTimeInSeconds * 1000 - Date.now() <= TEN_DAYS;
}

export interface TimeVal {
  days: number
  hours: number
  minutes: number
}

export function getTimeValFromMillisecond(t: number): TimeVal {
  const days = t / DAY;
  const hours = (days - Math.floor(days)) * 24;

  const minutes = (hours - Math.floor(hours)) * 60;

  return {
    days: Math.floor(days),
    hours: Math.floor(hours),
    minutes: Math.floor(minutes)
  }
}

export function formatToTimeString(timeToConvert: number): string {
  return timeToConvert < 10 ? `0${timeToConvert}` : String(timeToConvert);
}

export function toLocalDate(seconds: number) {
  return new Date(seconds * 1000);
}

export function daysDifferentFromTimeToTime(startDaySeconds: number, endDaySeconds: number): number {
  const startDate = toLocalDate(startDaySeconds);
  const endDate = toLocalDate(endDaySeconds);

  const diff = startDate.getTime() - endDate.getTime();

  return Math.abs(diff) / DAY;
}
